<div class="center-xy">
    <div class='statistics__loading' *ngIf="alarmHistory.loading">
            <div class="statistics__loading__img">
                <loader></loader>
            </div>
    </div>

    <div class="alarm-history-wrapper">
        <div class="alarm-history bg-light" [ngStyle]="{'height': views.alarmHistoryContentHeight}">
            <img class="alarm-history__icon bg-style bg-style__icon border-light" src="/assets/img/id_icons/122.svg" alt="">
            <div class="alarm-history__title bg-style color-light font-24 font-bold">{{ subtitles.setSubtitle(1170) }}</div>
            <div class="alarm-history__header">
                <div class="alarm-history__header-item">
                    <p class="alarm-history__item-title color-basic">{{ subtitles.setSubtitle(1104) }}</p>
                    <div class="alarm-history__input font-12 cursor-pointer border-input bg-input"
                         (click)="alarmHistory.setDatePicker('fromDate'); $event.stopPropagation()"
                         [ngClass]="{ 'border-zone': alarmHistory.showFromDatePicker, 'border-input': !alarmHistory.showFromDatePicker }">
                        {{ alarmHistory.fromDate }}
                    </div>
                    <div class="alarm-history__date-picker alarm-history__date-picker--from"
                         *ngIf="alarmHistory.showFromDatePicker">
                        <app-date-picker
                            [small]="true"
                            (dateChange)="setDate($event,'fromDate')" >
                        </app-date-picker>
                    </div>
                </div>

                <div class="alarm-history__header-item">
                    <p class="alarm-history__item-title color-basic">{{ subtitles.setSubtitle(1105) }}</p>
                    <div class="alarm-history__input font-12 cursor-pointer bg-input"
                         (click)="alarmHistory.setDatePicker('toDate'); $event.stopPropagation()"
                         [ngClass]="{ 'border-zone': alarmHistory.showToDatePicker, 'border-input': !alarmHistory.showToDatePicker }">
                        {{ alarmHistory.toDate }}
                    </div>
                    <div class="alarm-history__date-picker alarm-history__date-picker--to"
                         *ngIf="alarmHistory.showToDatePicker">
                        <app-date-picker
                            [small]="true"
                            (dateChange)="setDate($event,'toDate')" >
                        </app-date-picker>
                    </div>
                </div>

                <div class="alarm-history__header-item">
                    <p class="alarm-history__item-title color-basic">{{ subtitles.setSubtitle(1036) }}</p>
                    <select [(ngModel)]="alarmHistory.type"
                            class="alarm-history__select cursor-pointer bg-input border-input">
                        <option value="all">{{ subtitles.setSubtitle(3469) }}</option>
                        <option value="alarm">{{ subtitles.setSubtitle(65) }}</option>
                        <option value="warning">{{ subtitles.setSubtitle(1063) }}</option>
                        <option value="notification">{{ subtitles.setSubtitle(3463) }}</option>
                    </select>
                </div>

                <div class="alarm-history__search cursor-pointer color-light bg-ok font-bold font-14"
                     (click)="alarmHistory.getAlarmHistory()">
                    {{ subtitles.setSubtitle(12852) }}
                </div>
            </div>

            <div class="alarm-history__header">
                <input class="alarm-history__input-search border-input"
                       (ngModelChange)="alarmHistory.searchText()"
                       (change)="onSearchTextChange()"
                       [(ngModel)]="alarmHistory.search.txt"
                       [placeholder]="subtitles.setSubtitle(1099)">
                <div class="alarm-history__search-counter font-14"
                     *ngIf="alarmHistory.search.txt.length && alarmHistory.alarm.length">
                    ({{ alarmHistory.alarm.length }})
                </div>
            </div>

            <div class="alarm-history__list" [ngStyle]="{'height': views.alarmHistoryListHeight}">
                <ng-container *ngIf="alarmHistory.alarm.length > 0; else emptyAlarmMessage">
                    <div class="alarm-history__item border-dark-grey-bottom"
                         *ngFor="let alarm of alarmHistory.alarm; let first = first"
                         [ngClass]="{ 'border-dark-grey-top': first }">
                        <div class="alarm-history__alarm-icon" [ngSwitch]="alarm.alarmType">
                            <img *ngSwitchCase="'alarm'" class="bg-cancel" src="/assets/img/id_icons/25.svg" alt="">
                            <img *ngSwitchCase="'warning'" class="bg-alert" src="/assets/img/id_icons/122.svg" alt="">
                            <img *ngSwitchCase="'notification'" class="bg-ok" src="/assets/img/id_icons/29.svg" alt="">
                        </div>
                        <div class="alarm-history__text-wrapper">
                            <div class="alarm-history__time-date font-14">
                                <div>{{ alarm.startAlarm }}</div>
                                <div>{{ alarm.clearAlarm || '- -' }}</div>
                            </div>
                            <div class="alarm-history__alarm-name">
                                {{ subtitles.setSubtitle(alarm.txtId) + ' ' + (alarm.value !== 0 ? alarm.value : '') | format: alarm.unit }}
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #emptyAlarmMessage>
                    <div class="alarm-history__empty-array">
                        <p>{{ subtitles.setSubtitle(1623) }}</p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="date-picker-bg"
         data-testid="date-picker-overlay"
         *ngIf="alarmHistory.showFromDatePicker || alarmHistory.showToDatePicker"
         (click)="alarmHistory.hideDatePicker()">
    </div>
</div>
